<template>
  <div style='max-height:340vh;min-height: 180vh;'>
    <FillStep />
    <div class='fill-warp'>
      <van-form>
        <van-form v-for='(workItem, workIndex) in workInfo' :key='workIndex'>
          <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="workItem.start_work_time"
            label="开始时间"
            placeholder="请选择开始时间"
            @click="startWorkTimeClick(workIndex)"
          />
          <van-popup v-model="startWorkTimeShowPicker" position="bottom">
            <van-datetime-picker
              :min-date="minDate"
              v-model="currentDate"
              type="year-month"
              @confirm="startWorkTimeConfirm"
              @cancel="startWorkTimeShowPicker = false"
            />
          </van-popup>
          <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="workItem.end_work_time"
            label="结束时间"
            placeholder="请选择结束时间"
            @click="endWorkTimeClick(workIndex)"
          />
          <van-popup v-model="endWorkTimeShowPicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              :min-date="minDate"
              type="year-month"
              @confirm="endWorkTimeConfirm"
              @cancel="endWorkTimeShowPicker = false"
            />
          </van-popup>
          <van-field
            @click='itemClick(workIndex)'
            v-model="workItem.work_address"
            clearable
            name="工作单位"
            label="工作单位"
            placeholder="请输入工作单位名称"
          />
          <van-field
            @click='itemClick(workIndex)'
            v-model="workItem.work_role"
            clearable
            name="任职岗位"
            label="任职岗位"
            placeholder="请输入岗位名称"
          />
          <van-field
          readonly
          clickable
          name="picker"
          :value="workItem.work_month_pay"
          label="月薪"
          placeholder="请选择月薪薪资"
          @click="itemClick(workIndex, 'work_month_pay')"
        />
        <van-popup v-model="salaryTypePicker" position="bottom">
          <van-picker show-toolbar
            @confirm="salaryTypeConfirm"
            @cancel="salaryTypePicker = false"
            :columns="salary" />
        </van-popup>
          <van-field
          readonly
          clickable
          name="picker"
          :value="workItem.work_year_pay"
          label="年薪"
          placeholder="请选择年薪薪资"
          @click="itemClick(workIndex, 'work_year_pay')"
        />
        <van-popup v-model="yearSalaryTypePicker" position="bottom">
          <van-picker show-toolbar
            @confirm="yearSalaryTypeConfirm"
            @cancel="yearSalaryTypePicker = false"
            :columns="yearSalary" />
        </van-popup>
          <van-field
            @click='itemClick(workIndex)'
            v-model="workItem.work_referener"
            clearable
            name="证明人"
            label="证明人"
            placeholder="请输入姓名"
          />
          <van-field
            @click='itemClick(workIndex)'
            v-model="workItem.work_relationship"
            clearable
            name="关系"
            label="关系"
            placeholder="请输入关系"
          />
          <van-field
            v-model="workItem.work_referener_phone"
            clearable
            maxlength="11"
            type='tel'
            name="手机号"
            label="手机号码"
            :rules="[{ required: false, message: '请填写手机号码' },{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误'}]"
            placeholder="请输入手机号码"
          />
          <div v-if='workInfo.length == 1 && workIndex == 0 '  style='margin:16px;'></div>
          <div v-else class="del-btn">
            <van-button color='#f8bb5b'  icon="delete-o" size='small'  @click="deleteInfo(workIndex)">删除</van-button>
          </div>
        </van-form>
        <div class='btn-sty'>
          <van-button plain block  icon="plus" v-if='workInfo.length < 2 '  @click="addWorkInfo">添加工作经历</van-button>
        </div>
        <div class='company-wrap'>
          <div class="van-multi-ellipsis--l2 select-content">
            如果您选择一家公司，以下哪些因素会左右您的决定（只能选择3项哟）：
          </div>
          <div class='tag-wrap'>
            <van-tag color='#747474' plain type="primary"  @click='clickTag(item,index)'  size="large" v-for="(item,index) in tagsList" :key='index' :style='{"background": item.isClick == true ? "#e39e54" : "", "color": item.isClick == true ? "white" : "" }'>{{item.name}}</van-tag>
            <van-field
              v-show='tagsList[8].isClick'
              v-model="tagsList[8].message"
              rows="4"
              autosize
              type="textarea"
              placeholder="请输入内容"
              style='height:100%;background: #F5F5F5;'
            />
          </div>
          
        </div>
        
        <div class='check-wrap'>
          <span>是否有亲友在公司入职：</span><van-switch active-color='#E39E54' size='30px' v-model="otherInfo.isChecked" />
        </div>
        <van-form v-show="otherInfo.isChecked">
          <van-field
            v-model="otherInfo.friend_name"
            clearable
            name="姓名"
            label="姓名"
            placeholder="请输入姓名"
          />
          <van-field
            v-model="otherInfo.friend_ship"
            clearable
            name="与本人关系"
            label="与本人关系"
            placeholder="请输入关系"
          />
        </van-form>
        <div style="margin: 80px 0px 16px 0px;">
          <van-button style='font-size:16px; border-radius:5px;'  block type="info" color='#E39E54'  @click="nextStep">确认</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import FillStep from "../userRegistration/comp/fillStep";
import { mapState, mapMutations } from "vuex";
import moment from "moment";
import { getNumArray, urlAddParams } from '@/utils/tool';
import _ from "lodash"
  export default {
    name:'work',
    data() {
      return {
        workInfo: [
          {
            start_work_time:'',
            end_work_time:'',
            work_address:'',
            work_role:'',
            work_month_pay:'',
            work_year_pay:'',
            work_referener:'',
            work_relationship:'',
            work_referener_phone:''
          }
        ],
        currentIndex: 0,
        minDate: new Date(1980, 0, 1),
        currentDate: new Date(),
        startWorkTimeShowPicker: false,
        endWorkTimeShowPicker: false,
        tagsList: [
          {'name':'薪资', 'isClick': false, 'message':'薪资'}, 
          {'name':'距离','isClick': false, 'message':'距离'}, 
          {'name':'成长空间','isClick': false, 'message':'成长空间'},
          {'name':'培训机会多','isClick': false, 'message':'培训机会多'},
          {'name':'福利','isClick': false, 'message':'福利'},
          {'name':'制度完善','isClick': false, 'message':'制度完善'},
          {'name':'企业文化','isClick': false, 'message':'企业文化'},
          {'name':'公司规模','isClick': false, 'message':'公司规模'},
          {'name':'其他','isClick': false, 'message':''}
        ],
        hasSelectArr: [],
        otherInfo: {
          isChecked: false,
          friend_name:'',
          friend_ship:''
        },
        salaryTypePicker: false,
        salary: [
          {
            values: [],
            defaultIndex: 1,
          }
        ],
        
        yearSalaryTypePicker: false,
        yearSalary: [
          {
            values: [],
            defaultIndex: 1,
          }
        ],
      }
    },
    beforeRouteLeave(to, from, next){
      if(this.otherInfo.isChecked){
        this.otherInfo.isChecked = 1;
      }else{
        this.otherInfo.isChecked = 0;
      }
      if(!this.isCheck()){
          this.$toast({
            message: "请至少选择一项因素！",
            icon:'warning-o',
            duration: 2500
          })
        return
      }else{
        localStorage.setItem('work', JSON.stringify(Object.assign({}, {"workInfo": this.workInfo}, {"tags": this.tagsList}, {"otherInfo": this.otherInfo}) ))
        next()
      }
      
    },
    components:{
      FillStep
    },
    computed:{
      ...mapState([ "workExp" ]),
    },
    watch: {
      tagsList: {
        handler(newVal) {
          if (newVal?.length) {
            this.hasSelectArr = newVal.filter(item => item.isClick === true);
          }
        },
        deep: true
      }
    },
    mounted() {
      window.scrollTo(0,0)
      let data = JSON.parse(localStorage.getItem('work'))
      if(data != null){
        this.workInfo = data.workInfo;
        data?.tags?.length && (this.tagsList = data.tags);
        if(data.otherInfo.isChecked == 0){
          data.otherInfo.isChecked = false
        }else{
          data.otherInfo.isChecked = true
        }
        this.otherInfo = data.otherInfo;
      }
      let tmpNum = []
      _.map(getNumArray(1, 100), item => {
        tmpNum.push(item+"K")
      })
      this.salary[0].values  =  _.cloneDeep(tmpNum);
      // let tmpMonth = _.cloneDeep(tmpNum)
      // tmpMonth.splice(0,1)
      // cons
      // this.salary[1].values = tmpMonth;


      let yearNum = []
      _.map(getNumArray(1, 200), item => {
        yearNum.push(item+"W")
      })
      this.yearSalary[0].values = _.cloneDeep(yearNum);
      // let tmpYear = _.cloneDeep(yearNum)
      // tmpYear.splice(0,1)
      // this.yearSalary[1].values = tmpYear;
    },
    methods:{
      ...mapMutations([ "SET_WORKEXP_INFO" ]),
      // monthChange(picker, val){
      //   let index = this.salary[0].values.indexOf(val[0]);
      //   let tmpData = _.cloneDeep(this.salary[0].values);
      //   this.salary[1].values = tmpData
      //   this.salary[1].values.splice(0, 1)
      //   this.salary[1].defaultIndex = index;
      // },
      salaryTypeConfirm(val){
        this.workInfo[this.currentIndex].work_month_pay = val[0]
        this.salaryTypePicker = false;
      },
      // yearChange(picker, val){
      //   let index = this.yearSalary[0].values.indexOf(val[0]);
      //   let tmpData = _.cloneDeep(this.yearSalary[0].values);
      //   this.yearSalary[1].values = tmpData
      //   this.yearSalary[1].values.splice(0, 1)
      //   this.yearSalary[1].defaultIndex = index;
      // },
      yearSalaryTypeConfirm(val){
        this.workInfo[this.currentIndex].work_year_pay = val[0]
        this.yearSalaryTypePicker = false;
      },
      isCheck(){
        let flag = false;
        let arr = this.tagsList.filter(item => {
          return item.isClick == true
        })
        if(arr.length > 0){
          flag = true
        }else{
          flag = false
        }
        return flag
      },
      nextStep(){
        let defaultData = Object.assign({}, {"workInfo": this.workInfo}, {"tags": this.tagsList}, {"otherInfo": this.otherInfo})
        this.SET_WORKEXP_INFO(defaultData)
        const path = urlAddParams('/signature', this.$route.query);
        this.$router.replace(path);
      },
      clickTag(val,index){
        if(this.hasSelectArr.length >= 3){
          if(this.tagsList[index].isClick){
            this.tagsList[index].isClick = !this.tagsList[index].isClick;
            this.hasSelectArr = this.tagsList.filter(item => {
                return item.isClick === true
            })
          } else {
            this.$toast({
              message: '最多可选择3项',
              duration: 2500
            })
          }
        }else{
          this.tagsList[index].isClick = !this.tagsList[index].isClick;
          this.hasSelectArr = this.tagsList.filter(item => {
              return item.isClick === true
          })
          // if(val.name == "其他" && this.tagsList[index].isClick){
          //   this.isOpen = true;
          // }
        }
        
        
      },
      // TODO：后续有时间可重构页面
      itemClick(val, type){
        this.currentIndex = val;
        if (type === 'work_month_pay') {
          this.salaryTypePicker = true;
        } else if (type === 'work_year_pay') {
          this.yearSalaryTypePicker = true;
        }
      },
      startWorkTimeConfirm(val){
        this.workInfo[this.currentIndex].start_work_time = moment(val).format("YYYY-MM");
        this.startWorkTimeShowPicker = false;
      },
      startWorkTimeClick(val){
        this.startWorkTimeShowPicker = true;
        this.currentIndex = val;
      },
      endWorkTimeConfirm(val){
        this.workInfo[this.currentIndex].end_work_time = moment(val).format("YYYY-MM");
        this.endWorkTimeShowPicker = false;
      },
      endWorkTimeClick(val){
        this.endWorkTimeShowPicker = true;
        this.currentIndex = val;
      },
      addWorkInfo(){
        this.workInfo.push({
          start_work_time:'',
          end_work_time:'',
          work_address:'',
          work_role:'',
          work_month_pay:'',
          work_year_pay:'',
          work_referener:'',
          work_relationship:'',
          work_referener_phone:''
        })
        this.currentIndex = this.workInfo.length - 1;
      },
      deleteInfo(index){
        this.workInfo.splice(index, 1)
      },
    },
    
  }
</script>

<style lang="less" scoped>
@import "../../assets/css/page.css";
.btn-sty{
  // margin: 16px;
  color:#E39E54;
  .van-button{
    background: #FFECD8;
    color:#E39E54;
  }
  border-radius: 4px;
}
.company-wrap{
  background: #FFFFFF;
  padding: 16px;
  margin-top: 40px;
}
.tag-wrap{
  margin-top: 16px;
  .van-tag{
    color: #323232;
    line-height: 21px;
    padding:9px 21px;
    margin: 0px 12px 10px 0;
    
  }
}
.van-tag{
    font-size: 15px;
    margin: 9px 21px;
  }
.select-content{
    font-weight: 400;
    color: black;
    line-height: 21px;
  }
  .check-wrap{
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    background: #ffffff;
    padding: 16px;
    margin-top: 16px;
  }
  .van-tag--plain::before{
    border-radius: 4px;
    border: 1px solid #DCDCDC;
  }
</style>
